import { render, staticRenderFns } from "./SShareLink.vue?vue&type=template&id=ad3537b8&scoped=true"
import script from "./sShareLink.ts?vue&type=script&lang=ts&external"
export * from "./sShareLink.ts?vue&type=script&lang=ts&external"
import style0 from "./SShareLink.vue?vue&type=style&index=0&id=ad3537b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3537b8",
  null
  
)

export default component.exports